/**
 * Copyright (c) 2021 Interacso
 * All rights reserved.
 */

import React, { useEffect, useState } from "react";
import Player from "./Player";
import { parse } from "query-string";

import { api, headers } from "./helpers";

function ExternalPlayer() {
  const [creativeId, setCreativeId] = useState(null);
  const query = parse(document.location.search);

  useEffect(() => {
    const resourceId =
      query["com.broadsign.suite.bsp.resource_id"] ||
      query.ResourceID ||
      window.BroadSignObject?.player_id ||
      process.env.REACT_APP_DEFAULT_BSPLAYER_ID;

    const frameId =
      window.BroadSignObject?.frame_id ||
      query["com.broadsign.suite.bsp.frame_id"] ||
      query.frame_id ||
      query.frameId;

    console.log("BroadSignObject: ", window.BroadSignObject);
    
    if(!resourceId) {
      throw new Error('No query param for ResourceID. Include ResourceID or com.broadsign.suite.bsp.resource_id')
    }

    async function fetchAllCreatives() {
      if (!resourceId) {
        throw new Error("PlayerId is required for External Player");
      }

      let url = `${api}/external/creatives?player=${resourceId}`;

      if (frameId) {
        url += `&frame=${frameId}`;
      }

      const options = {
        method: "GET",
        headers: headers(),
      };

      try {
        const response = await window.fetch(url, options);

        if (!response.ok) {
          const responseText = await response.text();
          throw new Error(responseText);
        }

        const creativeIds = await response.json();

        const nextCreativeId = findNextCreative(creativeIds);

        setCreativeId(nextCreativeId);
      } catch (error) {
        setCreativeId(null);
        console.error(error);
      }
    }

    fetchAllCreatives()
  }, []);

  function findNextCreative(creatives) {
    const lastCreative = localStorage.getItem("last-creativity");
    let nextCreative = null;

    if (lastCreative) {
      const index = creatives.indexOf(lastCreative);

      if (index !== -1) {
        if (index + 1 < creatives.length) {
          nextCreative = creatives[index + 1];
        } else {
          nextCreative = creatives[0];
        }
      } else {
        nextCreative = creatives[0];
      }
    } else {
      nextCreative = creatives[0];
    }

    localStorage.setItem("last-creativity", nextCreative);

    return nextCreative;
  }

  if (creativeId) {
    return <Player creativeId={creativeId} />;
  }

  return null;
}

export default ExternalPlayer;
